import { render, staticRenderFns } from "./DataTables.vue?vue&type=template&id=18d8b6af&scoped=true"
import script from "./DataTables.vue?vue&type=script&lang=js"
export * from "./DataTables.vue?vue&type=script&lang=js"
import style0 from "./DataTables.vue?vue&type=style&index=0&id=18d8b6af&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8b6af",
  null
  
)

export default component.exports